// REACT & Libraries
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import DataTable from "react-data-table-component";
import FilterComponent from "../../Common/FilterComponent";

// Table
import { EmpStatusTableColumn } from "../../../../Data/DataTables/EmployeeStatus";

// Types
import { ViewEmployeeStatus } from "../../../../Types/MasterData/EmployeeStatus";

// Services
import {
  VIEW_EMPSTATUS_QUERY_KEY,
  employeeStatusService,
} from "../../../../Services/employeeStatusServices";

const EmployeeStatusTable = () => {
  const [filterText, setFilterText] = useState("");
  const { data: usersResponse, isLoading } = useQuery({
    queryKey: VIEW_EMPSTATUS_QUERY_KEY,
    queryFn: employeeStatusService.viewAllEmployeeStatus,
  });

  const filteredItems: ViewEmployeeStatus[] = usersResponse?.data.filter(
    (item: ViewEmployeeStatus) =>
      Object.values(item).some(
        (value) =>
          value &&
          value.toString().toLowerCase().includes(filterText.toLowerCase()),
      ),
  );

  const customStyles = {
    rows: {
      style: {
        whiteSpace: "nowrap",
      },
    },
    cells: {
      style: {
        whiteSpace: "nowrap",
        marginTop: "8px",
        marginBottom: "8px",
      },
    },
  };

  return (
    <>
      <FilterComponent
        onFilter={(e: React.ChangeEvent<HTMLInputElement>) =>
          setFilterText(e.target.value)
        }
        filterText={filterText}
      />
      <div className="table-responsive">
        <DataTable
          className="display nowrap custom-scrollbar"
          data={filteredItems}
          columns={EmpStatusTableColumn}
          striped={true}
          pagination
          progressPending={isLoading}
          highlightOnHover={true}
          fixedHeader={true}
          customStyles={customStyles}
        />
      </div>
    </>
  );
};

export default EmployeeStatusTable;
